import {
  Component,
  ChangeDetectionStrategy,
  LOCALE_ID,
  Inject,
  ApplicationRef
} from '@angular/core';
import { filter, first, switchMap, map, delay, tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import {
  BehaviorSubject,
  of,
  fromEvent
} from 'rxjs';
import { CheckForUpdateService } from './check-for-update.service';
import { LifeCycleService } from '../life-cycle/life-cycle.service';

export const SKIP_APP_INSTALL = 'skip-app-install';

@Component({
  selector: 'dx-root',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RootComponent {
  public promptEvent$ = new BehaviorSubject(null);

  constructor(
    public update: CheckForUpdateService,
    translate: TranslateService,
    @Inject(LOCALE_ID) localId: string,
    public lifeCycle: LifeCycleService
  ) {
    translate.setDefaultLang('de-DE');
    translate.use(localId);
    this.update.start();

    if (!localStorage.getItem(SKIP_APP_INSTALL)) {

      fromEvent(window, 'beforeinstallprompt').pipe(
        switchMap(event => this.lifeCycle.whenAuthorised(() => of(event).pipe(
          tap(() => this.promptEvent$.next(event)),
          delay(2 * 60 * 100),
          tap(() => this.promptEvent$.next(null)),
        )))
      ).subscribe();

    }
  }

  installPwa(): void {
    this.promptEvent$.value.prompt();
    this.promptEvent$.next(null);
  }

  notInstallPwa() {
    this.promptEvent$.next(null);
    localStorage.setItem(SKIP_APP_INSTALL, 'true');
  }
}
